module.exports = __webpack_public_path__ + "img/black_fire_crew-600.cbcc2207.png";